import { RouteConfig } from '../interface'

const walletRoutes: RouteConfig[] = [
  {
    path: '/shopee-food/wallet',
    children: [
      {
        path: '/shopee-food/wallet/balance',
        component: () =>
          import(/* webpackChunkName: "Wallet-Balance" */ '@/pages/Wallet/Balance/List'),
      },
      {
        path: '/shopee-food/wallet/settlement',
        redirect: '/shopee-food/wallet/settlement/on-hold',
      },
      {
        path: '/shopee-food/wallet/settlement/:tab',
        component: () =>
          import(/* webpackChunkName: "Wallet-Settlement" */ '@/pages/Wallet/Settlement'),
      },
      {
        path: '/shopee-food/wallet/settled-settlement/:id',
        component: () =>
          import(
            /* webpackChunkName: "Wallet-Settled-Settlement" */ '@/pages/Wallet/Settlement/SettledSettlement'
          ),
      },
      {
        path: '/shopee-food/wallet/transaction',
        component: () =>
          import(/* webpackChunkName: "Wallet-Transaction" */ '@/pages/Wallet/Transaction/List'),
      },
      {
        path: '/shopee-food/wallet/setting',
        component: () => import(/* webpackChunkName: "Wallet-Setting" */ '@/pages/Wallet/Setting'),
      },
    ],
  },
  {
    path: '/shopee-food/ereceipt',
    component: () => import(/* webpackChunkName: "Tax-Invoice" */ '@/pages/TaxInvoice'),
  },
]

export default walletRoutes
